import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Button,
  Row,
  Col,
} from "reactstrap";
import CoreEngine from "../../core/CoreEngine";
import RequestEngine from "../../core/RequestEngine";
import { connect } from "react-redux";
import loadingAction from "../../core/redux/actions/loadingAction";
import ReactTable from "react-table";
import TablePagination from "components/Table/TablePagination";
import strings from "../../core/translate";
import RowActions, {
  editAction,
  deleteAction,
} from "components/Table/RowActions";
import Constants from "../../core/Constants";
import SelectRow from "../../components/Select/SelectRow";
import { Scopes } from "../../shared/scopes.enum";

class MerchantItemList extends CoreEngine {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      dataSource: [],
      globalFilter: "",
      startDateFilter: null,
      endDateFilter: null,
      canWrite: false,
    };

    this.engine = new RequestEngine();
  }
  componentDidMount() {
    const merchantIdFromStorage = sessionStorage.getItem("merchantId");
    const { selectedMerchant } = this.props.match.params;
    const canWrite = this.hasPermission([Scopes.MERCHANTS_ITEMS_WRITE]);
    this.setState({ canWrite });

    if (merchantIdFromStorage) {
      this.setState({ selectedMerchant: merchantIdFromStorage }, this.callPage);
      this.fetchMerchants();
    } else if (selectedMerchant !== ":selectedMerchant") {
      this.setState({ selectedMerchant }, this.callPage);
      this.fetchMerchants();
    } else {
      this.fetchMerchants();
    }
  }

  fetchMerchants = async () => {
    const response = await this.engine.getItem("merchants");
    if (response && response.status === 200) {
      this.setState({
        isLoading: false,
        merchants: response.data.items.map((merchant) => ({
          value: merchant.id,
          label: merchant.name,
        })),
      });
      if (this.state.merchants.length === 1) {
        this.setState({
          selectedMerchant: this.state.merchants[0].value,
        });
        this.callPage();
      }
    }
  };

  async handleDelete(valueid) {
    const { selectedMerchant } = this.state;
    if (window.confirm(strings.confirmdelete)) {
      this.props.loadingAction(true);
      const result = await this.engine.deleteItem(
        `merchants/${selectedMerchant}/items`,
        valueid
      );
      if (result) {
        this.handlePage();
      }
      this.props.loadingAction(false);
    }
  }

  handleEdit(index, dataid) {
    const data = this.state.dataSource[index].data;
    const { selectedMerchant } = this.state;
    this.props.history.push({
      pathname: `/admin/merchant/${selectedMerchant}/items/edit/${dataid}`,
      data,
    });
  }
  handleMerchantSelect = (event) => {
    const selectedMerchant = event.target.value;
    this.setState({ selectedMerchant }, () => {
      this.props.history.push(`/admin/merchant/${selectedMerchant}/items`);
      this.callPage();
    });
  };

  async handleSync() {
    this.setState({ isLoading: true });
    const { selectedMerchant } = this.state;
    if (!selectedMerchant) return;

    const pathname = `merchants/${selectedMerchant}/sub-items/sync`;

    try {
      const response = await this.engine.getItem(pathname);
      if (response && response.status === 200) this.callPage();
    } catch (error) {
      alert("Something went Wrong: ", error.message);
    }
    this.setState({ isLoading: false });
  }

  handleActions(index, item) {
    return (
      <RowActions
        actions={[
          editAction(() => this.handleEdit(index, item.id), this.state.canWrite),
          deleteAction(() => this.handleDelete(item.id), this.state.canWrite),
        ]}
      />
    );
  }
  async callPage() {
    const { selectedMerchant } = this.state;
    if (!selectedMerchant) return;

    const pathname = `merchants/${selectedMerchant}/items`;
    const response = await this.engine.getItem(pathname);
    console.log("check response", response);

    // Check if response.data and response.data.items exist and if they are an array
    if (response && response.status === 200) {
      this.setState({
        isLoading: false,
        dataSource: response.data.items.map((item, key) => ({
          id: key,
          data: item,
          code: item.code,
          description: item.description,
          image:
            item.imageUrl && item.imageUrl.length > 1 ? (
              <img
                key={key}
                src={`${Constants.serverlink}api/v1/${pathname}/${item.imageUrl}`}
                className={"imgsponser"}
              />
            ) : (
              "-"
            ),
          merchant: item.merchant.name,
          branch: item.branch?.address,
          created: new Date(item.createdAt),
          actions: this.handleActions(key, item),
        })),
      });
    }

    this.props.loadingAction(false);
  }
  handlePage() {
    this.props.loadingAction(true);
    this.callPage();
  }

  handleAdd = () => {
    const { selectedMerchant } = this.state;
    if (!selectedMerchant) {
      alert(strings.select + " " + strings.merchant);
      return;
    }
    this.props.history.push(`/admin/merchant/${selectedMerchant}/items/add`);
  };

  render() {
    const { dataSource, isLoading, merchants, selectedMerchant, canWrite } =
      this.state;

    let columns = [
      {
        Header: strings.code,
        accessor: "code",
      },
      {
        Header: strings.description,
        accessor: "description",
      },
      {
        Header: strings.picture,
        accessor: "image",
      },
      {
        Header: strings.merchant,
        accessor: "merchant",
      },
      {
        Header: strings.branch,
        accessor: "branch",
      },

      {
        Header: strings.created,
        accessor: "created",
        Cell: (row) => row.value.toLocaleDateString(),
      },
      {
        Header: strings.actions,
        accessor: "actions",
        sortable: false,
        filterable: false,
      },
    ];

    return (
      <>
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <CardTitle tag="h4" className="pull-left"></CardTitle>
                  {canWrite && (
                    <>
                      <Button
                        color="primary"
                        className="pull-right"
                        onClick={() => this.handleAdd()}
                      >
                        {strings.add}
                      </Button>
                      <Button
                        className="hover-button pull-left"
                        onClick={() => this.handleSync()}
                      >
                        {strings.sync}
                      </Button>
                    </>
                  )}
                  {!sessionStorage.getItem("merchantId") &&
                    merchants.length !== 1 && (
                      <SelectRow
                        label={strings.merchant}
                        name="selectedMerchant"
                        defaultValue={selectedMerchant}
                        data={merchants}
                        changeInput={(e) => {
                          const selectedMerchant = e.value;
                          this.setState({ selectedMerchant }, () => {
                            this.props.history.push(
                              `/admin/merchant/${selectedMerchant}/branches`
                            );
                            this.callPage();
                          });
                        }}
                        placeholder={strings.select}
                      />
                    )}
                </CardHeader>
                <CardBody>
                  <ReactTable
                    previousText={strings.previous}
                    nextText={strings.next}
                    loadingText={strings.loading}
                    noDataText={strings.nodata}
                    pageText={strings.page}
                    data={dataSource}
                    defaultFilterMethod={this.filterCaseInsensitive}
                    filterable
                    loading={isLoading}
                    columns={columns}
                    defaultPageSize={10}
                    showPaginationTop={false}
                    showPaginationBottom
                    PaginationComponent={TablePagination}
                    /*
                                          You can choose between primary-pagination, info-pagination, success-pagination, warning-pagination, danger-pagination or none - which will make the pagination buttons gray
                                        */
                    className="-striped -highlight primary-pagination"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadingAction: (payload) => dispatch(loadingAction(payload)),
});
export default connect(null, mapDispatchToProps)(MerchantItemList);
